<div *ngIf="src" [nbSpinner]="loading" [ngStyle]="{width: width, height: height}" style="text-align: center;overflow: hidden;">
  <img *ngIf="isVisible" style="border-radius: {{borderRadius}}; object-fit: {{objectFit}};width: {{width}}; height: {{height}};" class="{{imgClass}}" src="{{src}}" (load)="onFinishLoad()" (error)="onError()"  alt="imagen"/>
</div>

